import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {MeetingsComponent} from '../../src/app/screens/meetings/meetings.component';
import {CalendarComponent} from '../../src/app/screens/calendar/calendar.component';
import {MeetingDetailsComponent} from '../../src/app/screens/meeting-details/meeting-details.component';
import {TaskListComponent} from '../app/screens/task-list/task-list.component';
import {PastMeetingsListComponent} from '../app/components/past-meetings-list/past-meetings-list.component';
import {ScheduleAndInstantComponent} from './screens/ScheduleAndInstant/schedule-and-instant/schedule-and-instant.component';
import {InstantMeetingCreatedComponent} from './screens/instant-meeting-created/instant-meeting-created.component';
import {FixedPreviousMeetingComponent} from './screens/fixed-previous-meeting/fixed-previous-meeting.component';
import {MinutesOfMeetingComponent} from './screens/minutes-of-meeting/minutes-of-meeting.component';
import {GridTableComponent} from './components/grid-table/grid-table.component';
import {SearchPageComponent} from '../../src/app/screens/search-page/search-page.component';
import { LoginPageComponent } from './screens/login-page/login-page.component';
import {SettingsPageComponent} from './screens/settings-page/settings-page.component';
import {ProfilePageComponent} from './screens/profile-page/profile-page.component';
import { AuthGuard } from './service/auth.guard';
import {PasswordCreationComponent} from './screens/password-creation/password-creation.component';
import { ForgotPasswordPageComponent } from './screens/forgot-password-page/forgot-password-page.component';
import { CreateMeetingTemplateViewComponent } from './screens/create-meeting-template-view/create-meeting-template-view.component';
import {ActivateUserViewComponent} from './screens/activate-user-view/activate-user-view.component';
import { ApprovedMeetingPageComponent } from './screens/approved-meeting-page/approved-meeting-page.component';
import { ErrorPageComponent } from './screens/error-page/error-page.component';
import { HelpVideoViewComponent } from './screens/help-video-view/help-video-view.component';
import { ZoomOAuthComponent } from '../app/components/zoom-oauth/zoom-oauth.component';
import { ReportComponent } from './components/report/report.component';
import { PhemeComponent } from './components/pheme/pheme.component';
import { PhemeReportsComponent } from './components/pheme-reports/pheme-reports.component';
import { HistoryComponent } from './components/history/history.component';
import { HelpVideoWebComponent } from './screens/help-video-web/help-video-web.component';
import { AdvanceSearchComponent } from './components/advance-search/advance-search.component';
import { GridDashboardComponent } from './components/grid-dashboard/grid-dashboard.component';

const routes: Routes = [
  {
    path : '',
    component : LoginPageComponent
  },
  {
    path : 'login',
    component : LoginPageComponent
  },
  {
    path : 'help',
    component : HelpVideoViewComponent,
    data: {title: 'help'}
    // canActivate: [AuthGuard]
  },
  {
    path : 'helpweb',
    component : HelpVideoWebComponent,
    data: {title: 'help-web'}
    // canActivate: [AuthGuard]
  },
  {
    path : 'dashboard',
    component : MeetingsComponent,
    canActivate: [AuthGuard],
     data: {title: 'Dashboard'}
  },
  {
    path : 'events',
    component : MeetingDetailsComponent,
     canActivate: [AuthGuard]
  },
  {
    path : 'tasks',
    component : TaskListComponent,
    canActivate: [AuthGuard]
  },
  {
    path : 'pastMeetings',
    component : PastMeetingsListComponent,
    canActivate: [AuthGuard]
  },
  {
    path : 'schedule',
    component : ScheduleAndInstantComponent,
    canActivate: [AuthGuard],
    data: {title: 'Meeting'}
  },
  {
    path : 'dashboard/schedule',
    component : ScheduleAndInstantComponent,
    canActivate: [AuthGuard],
    data: {title: 'Meeting'}
  },
  {
    path : 'instantMeeting',
    component : InstantMeetingCreatedComponent
  },
  {
    path : 'pinnedDialog',
    component : FixedPreviousMeetingComponent 
  },
  {
    path : 'MoM',
    component : MinutesOfMeetingComponent,
    canActivate: [AuthGuard]
  },
  {
    path : 'search',
    component : SearchPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path : 'settings',
    component : SettingsPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path : 'profile',
    component : ProfilePageComponent,
    canActivate: [AuthGuard]
  },
  {
    path : 'passwordCreation',
    component : PasswordCreationComponent,
    
  },
  {
    path : 'forgotPassword',
    component : ForgotPasswordPageComponent
  },
  {
    path : 'templateView',
    component : CreateMeetingTemplateViewComponent,
    canActivate: [AuthGuard]
  },
  {
    path : 'activateUser',
    component : ActivateUserViewComponent,
    canActivate: [AuthGuard]
  },
  {
    path : 'approvedMeeting',
    component: ApprovedMeetingPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path : 'error',
    component: ErrorPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path : 'zoomOAuth',
    component : ZoomOAuthComponent
    
  },
  {
    path:'report',
    component: ReportComponent,
    canActivate:[AuthGuard]
  },
  {
    path:'pheme',
    component: PhemeComponent,
    canActivate:[AuthGuard]
  },
  {
    path:'phemeReports',
    component: PhemeReportsComponent,
    canActivate:[AuthGuard]
  },
  {
    path:'history',
    component: HistoryComponent,
    canActivate:[AuthGuard]
  },
  {path:'advanceSearch',component:AdvanceSearchComponent},
  {
    path : 'gridDashboard',
    component : GridDashboardComponent,
    canActivate: [AuthGuard],
     data: {title: 'GridDashboard'}
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class AppRoutingModule { }
